import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Nav, NavItem, Button, PageHeader, Popover, Overlay} from 'react-bootstrap'
import moment from 'moment'
import cx from 'classnames'
import {percentage, average} from '../../core/mathz'
import {humanize} from '../../core/momentz'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import ProviderScores from './ProviderScores'
import ContactFilterModal from './ContactFilterModal'
import AssociateProviderContactWithProviderCompanyPopover from './AssociateProviderContactWithProviderCompanyPopover'
import AssociateDissociateProviderContactFromPatrimonyPopover from './AssociateDissociateProviderContactFromPatrimonyPopover'
import AssignRemoveActivityFromProviderContactPopover from './AssignRemoveActivityFromProviderContactPopover'
import UpdateProviderContactPopover from './UpdateProviderContactPopover'
import style from './ContactDetail.less'

class ContactDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {contactStats} = this.props
        const repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit
        const interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit

        const interventionDelay = average({source: contactStats.interventionDelay, identify: (v) => v.duration})
        const missionAcceptedDelay = average({source: contactStats.missionAcceptedDelay, identify: (v) => v.duration})
        const repairDelay = average({source: contactStats.repairDelay, identify: (v) => v.duration})
        const repairTimelimit = percentage({source: Object.keys(repairTimelimitStat), identify: (k) => repairTimelimitStat[k], match: (k) => k == 'ticketCompliant'})
        const interventionTimelimit = percentage({source: Object.keys(interventionTimelimitStat), identify: (k) => interventionTimelimitStat[k], match: (k) => k == 'ticketCompliant'})
        this.setState({aggregatedStats: {interventionDelay, missionAcceptedDelay, repairDelay, complianceWithCommitments: {repairTimelimit, interventionTimelimit}}})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.contactStats != this.props.contactStats) {
            const {contactStats} = nextProps
            const repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit
            const interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit

            const interventionDelay = average({source: contactStats.interventionDelay, identify: (v) => v.duration})
            const missionAcceptedDelay = average({source: contactStats.missionAcceptedDelay, identify: (v) => v.duration})
            const repairDelay = average({source: contactStats.repairDelay, identify: (v) => v.duration})
            const repairTimelimit = percentage({source: Object.keys(repairTimelimitStat), identify: (k) => repairTimelimitStat[k], match: (k) => k == 'ticketCompliant'})
            const interventionTimelimit = percentage({source: Object.keys(interventionTimelimitStat), identify: (k) => interventionTimelimitStat[k], match: (k) => k == 'ticketCompliant'})
            this.setState({aggregatedStats: {interventionDelay, missionAcceptedDelay, repairDelay, complianceWithCommitments: {repairTimelimit, interventionTimelimit}}})
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedPopover: null})
    }

    _openModal(event, name) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedModal: name})
    }

    _closeModal(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedModal: null})
    }
    
    render() {
        const {children, dispatch, location, contact, contactStats, contactFilter} = this.props
        const {openedPopover, openedModal, aggregatedStats} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {contact._links.find(linkFinder('AssociateProviderContactWithProviderCompany')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AssociateProviderContactWithProviderCompanyPopover')}>
                                <span>> {i18n.associateProvider}</span>
                            </a>
                        </li>
                    )}
                    {contact._links.find(linkFinder(['AssociateProviderContactWithPatrimony', 'DissociateProviderContactFromPatrimony'])) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AssociateDissociateProviderContactFromPatrimonyPopover')}>
                                <span>> {i18n.associateDissociatePatrimonies}</span>
                            </a>
                        </li>
                    )}
                    {contact._links.find(linkFinder(['AssignActivityToProviderContact', 'RemoveActivityFromProviderContact'])) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AssignRemoveActivityFromProviderContactPopover')}>
                                <span>> {i18n.assignRemoveActivities}</span>
                            </a>
                        </li>
                    )}
                    {contact._links.find(linkFinder('UpdateProviderContact')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdateProviderContactPopover')}>
                                <span>> {i18n.updateProviderContact}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={() => this._closePopover()}>
                {popover}
            </Overlay>
        )

        const complianceStatus = (percentage) => {
            if (percentage >= 85) return 'success'
            if (percentage >= 65) return 'warning'
            if (!isNaN(percentage)) return 'danger'
        }

        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{contact.name.firstName} {contact.name.lastName} {contact.name.value}</span>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {contact._links.find(linkFinder('AssociateProviderContactWithProviderCompany')) && editOverlay('AssociateProviderContactWithProviderCompanyPopover', (
                            <AssociateProviderContactWithProviderCompanyPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {contact._links.find(linkFinder(['AssociateProviderContactWithPatrimony', 'DissociateProviderContactFromPatrimony'])) && editOverlay('AssociateDissociateProviderContactFromPatrimonyPopover', (
                            <AssociateDissociateProviderContactFromPatrimonyPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {contact._links.find(linkFinder(['AssignActivityToProviderContact', 'RemoveActivityFromProviderContact'])) && editOverlay('AssignRemoveActivityFromProviderContactPopover', (
                            <AssignRemoveActivityFromProviderContactPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {contact._links.find(linkFinder('UpdateProviderContact')) && editOverlay('UpdateProviderContactPopover', (
                            <UpdateProviderContactPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                    </PageHeader>
                    <div className={style.filter}>
                        <a
                            href=''
                            onClick={(e) => this._openModal(e, 'ContactFilterModal')}>
                            {contactFilter && (contactFilter.from || contactFilter.to) && (
                                <span>
                                    <span>{contactFilter.from && moment(contactFilter.from).format(i18n.dateFormat.from)} </span>
                                    <span>{contactFilter.to && moment(contactFilter.to).format(i18n.dateFormat.to)} </span>
                                </span>
                            ) || (
                                <span>{i18n.selectDateRange} </span>
                            )}
                            <Icon icon='calendar' size='sm' />
                        </a>
                    </div>
                    <Row>
                        <Col sm={4}>
                            <div className={style.stats}>
                                <h4>{i18n.delays}</h4>
                                <div className={style.count}>
                                    <span>{aggregatedStats.interventionDelay && moment.duration(aggregatedStats.interventionDelay).humanize() || '---'}</span>
                                    <small>{i18n.intervention}</small>
                                </div>
                                <div className={style.count}>
                                    <span>{aggregatedStats.missionAcceptedDelay && moment.duration(aggregatedStats.missionAcceptedDelay).humanize() || '---'}</span>
                                    <small>{i18n.missionAccepted}</small>
                                </div>
                                <div className={style.count}>
                                    <span>{aggregatedStats.repairDelay && moment.duration(aggregatedStats.repairDelay).humanize() || '---'}</span>
                                    <small>{i18n.repair}</small>
                                </div>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <ProviderScores />
                        </Col>
                        <Col sm={4}>
                            <div className={style.stats}>
                                <h4>
                                    {i18n.commitments}
                                    <small>{i18n.commitmentCompliancyRate}</small>
                                </h4>
                                <div className={cx(style.count, style[complianceStatus(aggregatedStats.complianceWithCommitments.repairTimelimit)])}>
                                    {!isNaN(aggregatedStats.complianceWithCommitments.repairTimelimit) && (
                                        <span>{aggregatedStats.complianceWithCommitments.repairTimelimit} %</span>
                                    ) || '---'}
                                    <small>{i18n.repairDelay}</small>
                                </div>
                                <div className={cx(style.count, style[complianceStatus(aggregatedStats.complianceWithCommitments.interventionTimelimit)])}>
                                    {!isNaN(aggregatedStats.complianceWithCommitments.interventionTimelimit) && (
                                        <span>{aggregatedStats.complianceWithCommitments.interventionTimelimit} %</span>
                                    ) || '---'}
                                    <small>{i18n.interventionDelay}</small>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem
                            active={location.pathname.match(/\/providercontacts\/[\w-]+$/) != null}
                            onClick={() => dispatch(push('/providercontacts/' + contact.uid))}>
                            {i18n.synthesis}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/\/providercontacts\/[\w-]+\/tickets/) != null}
                            onClick={() => dispatch(push('/providercontacts/' + contact.uid + '/tickets'))}>
                            {i18n.tickets}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/\/providercontacts\/[\w-]+\/commitments/) != null}
                            onClick={() => dispatch(push('/providercontacts/' + contact.uid + '/commitments'))}>
                            {i18n.commitments}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.documents}
                        </NavItem>
                    </Nav>
                    <ContactFilterModal
                        show={openedModal == 'ContactFilterModal'}
                        onHide={() => this._closeModal()} />
                </div>
                {children}
            </div>
        )
    }
}

ContactDetail = connect((state) => ({
    location: state.router.location,
    contact: state.provider.contact.contact,
    contactStats: state.provider.contact.contactStats,
    contactFilter: state.provider.contact.contactFilter
}))(ContactDetail)

export default ContactDetail


// WEBPACK FOOTER //
// ./lib/provider/components/ContactDetail.js